module.exports = __webpack_public_path__ + "36a7470e7e47f4f14a7a871a40f01377.svg";